<template>
  <footer>
    <ul>
      <li></li>
      <li></li>
      <li></li>
    </ul>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      quote: 'much',
    }
  },
}
</script>
<style>
.container {
  display: grid;
}
</style>
